import React from 'react';
import {
  InstructionsOverlay,
  InstructionsModal,
  InstructionsTitle,
  Subtitle,
  InstructionsList,
  IconWrapper,
  ActionsWrapper,
  PrimaryButton,
  PrimaryButtonText
} from './styles';
import { Icon } from 'semantic-ui-react';

interface IosInstructionsModalProps {
  onClose: () => void;
}

const IosInstructionsModal: React.FC<IosInstructionsModalProps> = ({ onClose }) => {
  return (
    <InstructionsOverlay onClick={onClose}>
      <InstructionsModal onClick={(e) => e.stopPropagation()}>
        <InstructionsTitle>
          Instalar no <span>iOS</span>
        </InstructionsTitle>

        <Subtitle>
          Siga os passos abaixo para adicionar o app à sua tela inicial:
        </Subtitle>

        <InstructionsList>
          <li>
            Abra este site no navegador <strong>Safari</strong>
          </li>
          <li>
            Toque no botão de compartilhar
            <IconWrapper>
              <Icon name="external share" />
            </IconWrapper>
            na barra inferior
          </li>
          <li>
            Role para baixo e toque em <strong>"Adicionar à Tela de Início"</strong>
          </li>
          <li>
            Toque em <strong>"Adicionar"</strong> no canto superior direito
          </li>
        </InstructionsList>

        <ActionsWrapper>
          <PrimaryButton onClick={onClose}>
            <PrimaryButtonText>Entendi</PrimaryButtonText>
          </PrimaryButton>
        </ActionsWrapper>
      </InstructionsModal>
    </InstructionsOverlay>
  );
};

export default IosInstructionsModal;
